import React from "react";
import MDEditor from '@uiw/react-md-editor';
const modules = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
        ],
        ['link'],
        ['clean'],
    ],
};
const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
];
const TextEditor = ({ value, onChange, disabled }) => disabled ? null : (React.createElement("div", { "data-color-mode": "dark" },
    React.createElement(MDEditor, { value: value, onChange: onChange })));
export default TextEditor;
